import ScrollComponent from "components/ScrollComponent";
import useProfile from "hooks/useProfile";
import { useEffect, useRef } from "react";

const MainContentLeft = ({ getOpenedClass, filters, setOffsetCount }) => {
  const mainContentLeftRef = useRef(null);
  const { isMobile } = useProfile();

  const resetStyles = (element) => {
    if (element) {
      element.style.height = "";
      element.style.position = "relative";
    }
  };


  const applyFixedHeight = (element, height) => {
    if (element) {
      element.style.height = `${height - 20}px`;
      element.style.position = "";
    }
  };


  const updateHeight = () => {
    const ufVisibleElement = document.querySelector(".uf-visible");

    if (ufVisibleElement) {
      resetStyles(mainContentLeftRef.current);
      return;
    }

    const element = mainContentLeftRef.current;
    if (!isMobile && element && element.parentNode) {
      const parentNode = element.parentNode;
      const parentRect = parentNode.getBoundingClientRect();

      const visibleHeight = Math.max(
        0,
        Math.min(parentRect.bottom, window.innerHeight) - Math.max(parentRect.top, 0)
      );

      applyFixedHeight(element, visibleHeight);
    }
  };


  const handleResizeOrScroll = () => {
    requestAnimationFrame(updateHeight);
  };

  useEffect(() => {


    window.addEventListener("scroll", handleResizeOrScroll);
    window.addEventListener("resize", handleResizeOrScroll);
    updateHeight();

    return () => {
      window.removeEventListener("scroll", handleResizeOrScroll);
      window.removeEventListener("resize", handleResizeOrScroll);
    };
  }, [isMobile]);

  return (
    <div
      ref={mainContentLeftRef}
      className={`main-content__left ${getOpenedClass()}`}
    >
      {getOpenedClass() === "opened" && (
        <ScrollComponent
          filters={filters}
          setOffsetCount={setOffsetCount}
          parentRef={mainContentLeftRef}
        />
      )}
    </div>
  );
};

export default MainContentLeft;
